import { observer } from "mobx-react";
import React from "react";
import {CartesianGrid, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, Cell } from "recharts";
import adminStore from "../../stores/adminStore";
import { CustomTick } from "./FinishedPolls";

const width = window.innerWidth - 240 - 100
const height = 600
const colors = [ "#eeaa7b", "#66b9bf", "#c09f80", "#df744a", "#94618e", "#b56357"]

function scoreByData(data) {
	if (!data || data.length === 0) return null
    return (
        <BarChart width={width} height={height} data={data} margin={{bottom: 100}}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" interval={0} tick={<CustomTick />} />
            <YAxis />
            <Tooltip />
            <Bar dataKey="score">
				{ data.map((entry, index) => ( <Cell key={`cell-${index}`} fill={colors[index % 6]} />)) }
			</Bar>
        </BarChart>
    );
}

@observer
class ScoreByArea extends React.Component {
  render() {
    const { dashboard } = adminStore;
    if (!dashboard.scores_by_areas) {
      return <div></div>;
    }
    const data = dashboard.scores_by_areas.data
    return scoreByData(data)
  }
}

@observer
class ScoreByCharge extends React.Component {
    render() {
        const { dashboard } = adminStore;
        if (!dashboard.scores_by_charges) {
            return <div></div>;
        }
        const data = dashboard.scores_by_charges.data
        return scoreByData(data)
    }
}

function scoreByDataByData2(data, data2) {
	if (!data || !data2 || data.length === 0 || data2.length === 0) return null
    return (
        <BarChart width={width} height={height} data={data} margin={{bottom: 100}}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" interval={0} tick={<CustomTick />} />
            <YAxis />
            <Tooltip />
            <Legend verticalAlign='top' />
            {data2.map((c, i) =>
                <Bar key={`bar-${i}`} dataKey={c} fill={colors[i % colors.length]} />
            )}
        </BarChart>
    );
}

@observer
class ScoreByAreaByCompetence extends React.Component {
    render() {
        const { dashboard } = adminStore;
        if (!dashboard.scores_by_areas_by_competences) {
            return <div></div>;
        }
        const data = dashboard.scores_by_areas_by_competences.data
        const competences = dashboard.scores_by_areas_by_competences.competences
        return scoreByDataByData2(data, competences)
    }
}

@observer
class ScoreByChargeByCompetence extends React.Component {
    render() {
        const { dashboard } = adminStore;
        if (!dashboard.scores_by_charges_by_competences) {
            return <div></div>;
        }
        const data = dashboard.scores_by_charges_by_competences.data
        const competences = dashboard.scores_by_charges_by_competences.competences
        return scoreByDataByData2(data, competences)
    }
}


export { ScoreByArea, ScoreByCharge, ScoreByAreaByCompetence, ScoreByChargeByCompetence, scoreByDataByData2, scoreByData};

